import { FirebaseData } from "../General/FirebaseData";
import { UserData } from "../User/UserData";
import { LocalData } from "../General/LocalData";
import { ChatMessageData } from "./ChatMessageData";
import { Timestamp, DocumentReference, getFirestore, doc, updateDoc } from "firebase/firestore";
import { DataCreator } from "../../../utils/dataCreator";
import { DeviationData } from "../Deviation/DeviationData";
import CollectionLoader from "../General/CollectionLoader";

export class ChatData extends FirebaseData {
  name: string = "";
  updatedAt?: Date;
  lastMessage?: ChatMessageData;
  // use
  messages: CollectionLoader<ChatMessageData>;
  //
  members: UserData[] = [];
  savedRemotely = false;
  deviation?: DeviationData;

  lastSeenMessage: string = "";

  constructor(id: string, collectionName: string, parent: FirebaseData | undefined) {
    super(id, collectionName, parent);
    this.messages = new CollectionLoader<ChatMessageData>("messages", this, ChatMessageData);
  }

  setup(data: any) {
    if (super.isValidString(data.name)) {
      this.name = data.name;
    }

    // ReportDate
    if (data.updatedAt as Timestamp) {
      this.updatedAt = data.updatedAt.toDate();
    }
    if (this.isValidDate(data.updatedAt)) {
      this.updatedAt = data.updatedAt;
    }

    if (this.isValidString(data.lastMessage)) {
      this.lastMessage = this.messages.addData(data.lastMessage);
    }
    if (this.isValidObject(data.members)) {
      this.members = [];
      Object.keys(data.members).forEach((id) => {
        this.members.push(LocalData.users.addData(id));
        if (id === LocalData.currentUser.id) {
          this.lastSeenMessage = data.members[id].lastSeenMessage;
        }
      });
    }
    if (data.deviation as DocumentReference) {
      let reference = data.deviation as DocumentReference;
      if (this.isValidString(reference.path)) {
        let deviationRefElements = reference.path.split("/");
        if (deviationRefElements.length >= 4) {
          let propertyId = deviationRefElements[1];
          let deviationId = deviationRefElements[3];
          let deviation = LocalData.properties.addData(propertyId).deviations.addData(deviationId);
          this.deviation = deviation;
        }
      }
    }
    super.setup(data);
  }

  getName(): string {
    if (this.name !== "") {
      return this.name;
    }
    let name = "";
    let count = 0;
    this.members.forEach((user) => {
      if (user.loaded) {
        if (count !== 0) name += ", ";
        count += 1;
        name += user.name.split(" ")[0];
      }
    });
    return name;
  }

  delete(): Promise<any> {
    //Has to check if the chat is only a temporary chat not yet uploaded to DB
    if (this.id && this.id.length > 0) {
      const db = getFirestore();
      const chatRef = doc(db, "chats", this.id);
      return updateDoc(chatRef, {
        deletedBy: DataCreator.getDeletedBy(),
      }).then(() => {
        this.deleted = true;
        let currUserChats = LocalData.currentUser.chats;
        this.messages.removeAllRealtimeListeners();
        this.removeAllRealtimeListeners();
        currUserChats.splice(currUserChats.indexOf(this), 1);
      });
    } else {
      return new Promise((resolve) => resolve(null));
    }
  }
}
